// @generated by protoc-gen-connect-es v1.1.3 with parameter "target=ts"
// @generated from file gdx/gateway/web/notification/v1/notification_push_api.proto (package gdx.gateway.web.notification.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { RegisterPushTokenRequest, RegisterPushTokenResponse, RemoveUserTokensRequest, RemoveUserTokensResponse } from "./notification_push_api_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * Contains methods related to push notification processing.
 *
 * @generated from service gdx.gateway.web.notification.v1.NotificationPushAPI
 */
export const NotificationPushAPI = {
  typeName: "gdx.gateway.web.notification.v1.NotificationPushAPI",
  methods: {
    /**
     * Registers push token or replaces one in case of duplicate.
     *
     * @generated from rpc gdx.gateway.web.notification.v1.NotificationPushAPI.RegisterPushToken
     */
    registerPushToken: {
      name: "RegisterPushToken",
      I: RegisterPushTokenRequest,
      O: RegisterPushTokenResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Removes all token for user.
     *
     * @generated from rpc gdx.gateway.web.notification.v1.NotificationPushAPI.RemoveUserTokens
     */
    removeUserTokens: {
      name: "RemoveUserTokens",
      I: RemoveUserTokensRequest,
      O: RemoveUserTokensResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

